import React from "react";
import { getTasaDeCambio } from "../../utils/exchangeRate";

const Calculo = ({ cantidadEth, network, selectedTokenSymbol }) => {


  const tasaDeCambio = getTasaDeCambio(network, selectedTokenSymbol);
  
  const cantidadBtc = cantidadEth * tasaDeCambio; // Realizar el cálculo

  return <span>{cantidadBtc.toFixed(8)} </span>; // Mostrar el resultado con 8 decimales
};

export default Calculo;